import { CoordinatorService } from "./coordinator.service"
import { getStorage, ref, getDownloadURL } from 'firebase/storage'
export class Help$ {

    constructor(public coords: CoordinatorService) {

    }

    async dialog(helpId: string) {
        const blob = await this.coords.firebase$.storage
            .downloadFile2(`help/${helpId}`)
        let txt = await blob?.text()
        if (!txt)
            txt = this.coords.text("UnknownHelp: ") + helpId
        this.coords.display$.dialog$.next({ action: "help-in-context", txt, helpId })
    }

    async upload() {
        const ls: File[] = await this.coords.filesystem$.pickFiles(true)
        for (const f of ls) {
            let pth = `help/${f.name}`

            if (f.name.endsWith(".md"))
                pth = pth.split(".")[0]

            const resp = await this.coords.firebase$
                .storage.uploadFile(pth, f)
            console.log("UPLOAD", resp, pth)
        }

    }
}



